import isEmptyObject from './isEmptyObject';

// ----------------------------------------------------------------------------

function isEmptyObjectFor(...args: unknown[]): boolean {
    return args.every((item): any => isEmptyObject(item));
}

// ----------------------------------------------------------------------------

export default isEmptyObjectFor;
